@if (isArchived) {
  <!-- Workbench's theme="dark" is the light banner; without it the notification is dark grey with white text -->
  <wb-notification icon="archive-xs" [attr.theme]="variant === 'content' ? null : 'dark'" hide-dismiss-button>
    <wb-heading size="xs">{{ 'ARCHIVED_CONTENT' | translate }}</wb-heading>
    <wb-text size="m">{{
      (variant === 'content' ? 'ARCHIVED_CONTENT_TEXT' : 'ARCHIVED_PRESS_RELEASE_TEXT') | translate
    }}</wb-text>
    <!-- No legal page for EMPCO yet - re-enable once a target URL exists.
    <wb-link href="#" variant="inline">{{ 'ARCHIVED_PRESS_RELEASE_LINK' | translate }}</wb-link>
    -->
  </wb-notification>
}
